export const masterCategories = [
  { id: "museum_types", label: "Museum Type" },
  { id: "museum_exhibition_types", label: "Museum Exhibition Type" },
  { id: "visitor_types", label: "Visitor Type" },
  { id: "user_types", label: "User Type" },
  { id: "storage_rooms", label: "Storage Room" },
  { id: "csr_racks", label: "CSR Racks" },
  { id: "ownerships", label: "Ownership" },
  // { id: "accession_nos", label: "Accession No" },
  { id: "sources", label: "Sources" },
  { id: "object_groups", label: "Object Group" },
  { id: "object_sub_groups", label: "Object Sub Group" },
  { id: "materials", label: "Materials" },
  { id: "conditions", label: "Condition" },
  { id: "place_of_origins", label: "Place Of Origin" },
  { id: "currencies", label: "Currency" },
  { id: "acquisitions", label: "Acquisition" },
  // { id: "dimensions", label: "Dimension" },
  { id: "ticket_discounts", label: "Ticket Discount" },
];

export const defaultMockEntriesByCategory = {
  museum_types: [],
  museum_exhibition_types: [],
  visitor_types: [],
  user_types: [],
  storage_rooms: [],
  csr_racks: [],
  ownerships: [],
  accession_nos: [],
  sources: [],
  object_groups: [],
  object_sub_groups: [],
  materials: [],
  conditions: [],
  place_of_origins: [],
  currencies: [],
  acquisitions: [],
  dimensions: [],
  ticket_discounts: [],
};
